import { useCallback, useState } from 'react';
import { useRevealEngine } from './lib/motion';

import Boot from './components/Boot';
import Cursor from './components/Cursor';
import Backdrop from './components/Backdrop';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import Work from './components/Work';
import Architecture from './components/Architecture';
import Console from './components/Console';
import Studio from './components/Studio';
import Method from './components/Method';
import Stack from './components/Stack';
import Record from './components/Record';
import Contact from './components/Contact';
import Foot from './components/Foot';

export default function App() {
  const [ready, setReady] = useState(false);
  const onBootDone = useCallback(() => setReady(true), []);

  useRevealEngine(ready);

  return (
    <>
      <Boot onDone={onBootDone} />
      <Cursor />
      <Backdrop />

      <a href="#work" className="skip">Skip to content</a>

      <Nav ready={ready} />

      <main>
        <Hero ready={ready} />
        <Marquee />
        <Work />
        <span className="edge" />
        <Architecture />
        <span className="edge" />
        <Console />
        <span className="edge" />
        <Studio />
        <span className="edge" />
        <Method />
        <span className="edge" />
        <Stack />
        <span className="edge" />
        <Record />
        <Contact />
      </main>

      <Foot />
    </>
  );
}
